import { Collapse } from "bootstrap";

export const init = () => {
  // Init panels
  const collapseElementList = document.querySelectorAll(".collapse");
  const collapseList = [...collapseElementList].map(
    (collapseEl) => new Collapse('#' + collapseEl.id, { toggle: false })
  );

  collapseList.forEach(elem => {
    elem._element.addEventListener('hide.bs.collapse', e => {
      // console.log('Hides', e, e.target);
      e.target.parentElement.classList.remove('panel--open');
    });

    elem._element.addEventListener('show.bs.collapse', e => {
      e.target.parentElement.classList.add('panel--open');
    });
  })
};
